module.exports = __webpack_public_path__ + "img/bigLogo.d03179c1.png";